import React, { HTMLAttributes } from 'react';

const VisibilityOff = ({
  className,
}: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="2.83 4.39 18.33 15.27"
  >
    <path
      d="M12 7.417c2.3 0 4.167 1.866 4.167 4.166 0 .425-.083.834-.2 1.217l2.55 2.55a9.835 9.835 0 0 0 2.65-3.775c-1.442-3.65-5-6.242-9.167-6.242a9.875 9.875 0 0 0-3.033.475l1.808 1.809c.392-.117.8-.2 1.225-.2zM4.258 4.633a.83.83 0 0 0 0 1.175L5.9 7.45a9.91 9.91 0 0 0-3.067 4.133c1.442 3.659 5 6.25 9.167 6.25 1.266 0 2.475-.25 3.591-.683l2.267 2.267a.83.83 0 1 0 1.175-1.175L5.441 4.633a.84.84 0 0 0-1.183 0zM12 15.75a4.168 4.168 0 0 1-4.167-4.167c0-.641.15-1.25.409-1.783l1.308 1.308a2.87 2.87 0 0 0-.05.475c0 1.384 1.117 2.5 2.5 2.5.167 0 .317-.025.475-.058l1.308 1.308A4.01 4.01 0 0 1 12 15.75zm2.475-4.442a2.474 2.474 0 0 0-2.2-2.2l2.2 2.2z"
      fill="#1D1D1D"
    />
  </svg>
);

export default VisibilityOff;
